import axios from 'axios'
import moment from 'moment'
import {typesJetFly} from '../svtypes/flyTypes'
import { SV_SOJ_ORCMOCK_ADDRESS, SV_SOJ_SVDJMOCK_ADDRESS, SV_SOJ_SVDJMOCK_BRIDGE } from '../../constants';
const _ = require('lodash')
/*
import {
    browserHistory as history
  } from 'react-router'

*/
export function flyCountryCodeSV(sojPostRqFromPage,  svfly_esquery_data){
    console.log("sv NOV!5*** flyAndImagesSV ******sv_esquery_data********", svfly_esquery_data)
   
    
    return dispatch => {
        dispatch(getFlySearchBegin())
       //localhost:8000/amcosmosbika/ttsvfacetttr
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
        let urlBridge = null
        let urlSoj = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/ttsvfacetttr/`
        if(svfly_esquery_data && svfly_esquery_data['esqueryTripType']){
            if(svfly_esquery_data['esqueryTripType'] == 'onewaytrip'){
                urlSoj = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/ttsvfacetttr/`
                urlBridge = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/amcosmosbika/ttsvfacetttr/`
                urlSoj = SV_SOJ_SVDJMOCK_BRIDGE === "SVINGEST" ? urlBridge : urlSoj
            }else if(svfly_esquery_data['esqueryTripType'] == 'roundtrip'){
                urlSoj = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/eesvfaceteer`  
                urlBridge = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/amcosmosbika/eesvfaceteer`
                urlSoj = SV_SOJ_SVDJMOCK_BRIDGE === "SVINGEST" ? urlBridge : urlSoj

            }else if(svfly_esquery_data['esqueryTripType'] == 'multicity'){
                urlSoj = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/xxsvfacemultixx` 
                
                urlBridge = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/amcosmosbika/xxsvfacemultixx`
                urlSoj = SV_SOJ_SVDJMOCK_BRIDGE === "SVINGEST" ? urlBridge : urlSoj
                //essearch/xxsvfacemultixx 
                //urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/xxsvfacemultixx` 
            }else{
                urlSoj = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/ttsvfacetttr/`

                urlBridge = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/amcosmosbika/ttsvfacetttr/`
                urlSoj = SV_SOJ_SVDJMOCK_BRIDGE === "SVINGEST" ? urlBridge : urlSoj
            }
        }

        
       // const urlSoj = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/mmmockttsvfacetttr`

        //const urlSoj = 'http://127.0.0.1:8000/trip/kkfromtosv/'
        let sojPostRq_old = {
            "query": {
              "match": {
                "sojourn_name": {
                  "query": "mancreek",
                  "operator": "and"
                }
              }
            }
          }

          let sojPostRq = {
            "dates": {
                "STARTDATE_ITN_TZAWARE_EST": "2025-11-25",
                "ENDDATE_ITN_TZAWARE_EST": "2025-11-27",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "Asia/Kolkata",
                "OP": "range"
            },
             "org": "09A",
            "dst":"ADQ"
        }
        /*
{
          "AIRPORT_ID" : 298,
          "ORIGIN_AIRPORT_CODE" : "LFW",
          "ORIGINCITY" : "Lome",
          "ORIGIN_AIRPORT_CITY" : "Lome",
          "ORIGIN_AIRPORT_COUNTRY" : "Togo",
          "ORIGIN_AIRPORT_TIMEZONE" : "Africa/Lome",
          "PORT_CODE_IATA" : "2J",
          "AIRLINES_DB_ID" : 470,
          "ORIGIN_AIRPORT_IATA" : "LFW",
          "DST_AIRPORT_CODE" : "OUA",
          "AIRLINES_VESSEL" : "M87 CRJ",
          "AIRLINES_NAME" : "Air Burkina",
          "AIRLINES_CODE_IATA" : "2J",
          "FLIGHT_SPACE_ID" : 89,
          "STARTDATE" : "2023-11-24",
          "ENDDATE" : "2026-12-01",
          "FLIGHT_SPACE_KEY" : "LFW@2J@LFW@OUA"
        }

        */
       
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        if(sojPostRqFromPage){
            sojPostRq = sojPostRqFromPage
        }
        const urlGeoList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/geography`
        const bodyGeoList = {"docId":["USA"],"hsetname":"HotelInvDB"}
       
        axios.all([
          //  axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers}),
            axios.post(urlGeoList, bodyGeoList, {headers:headers}),
        ])
        .then(
            //axios.spread((rFobAx,r2,r5)=>{
            axios.spread((r2,r5)=>{
               // let rFob = rFobAx.data
               let rFob = [{
                "airport_id" : 298,
                "origin_airport_code" : "lfw",
                "origincity" : "lome",
                "origin_airport_city" : "lome",
                "origin_airport_country" : "togo",
                "origin_airport_timezone" : "africa/lome",
                "port_code_iata" : "2j",
                "airlines_db_id" : 470,
                "origin_airport_iata" : "lfw",
                "dst_airport_code" : "oua",
                "airlines_vessel" : "m87 crj",
                "airlines_name" : "air burkina",
                "airlines_code_iata" : "2j",
                "flight_space_id" : 89,
                "startdate" : "2023-11-24",
                "enddate" : "2026-12-01",
                "flight_space_key" : "lfw@2j@lfw@oua"
              }]
                let r = {data:{}}
                r.data = rFob
                let p = {data:{}}
                
                if(rFob.length < 1){
                    p.data.hits = { hits: []}
                    r.data.hits = { hits: []}

                }else{
                    p.data.hits = { hits: []}
                    r.data.hits = { hits: []}

                    p.data.hits.hits  = rFob
                    r.data.hits.hits  = rFob

                }
              
               
               
                
               
                console.log('sv**OCT23 WED ****************  amb flighyr START')
                console.log(r)
                console.log('sv**OCT23 WED **************** r  END')
                if(r.data.hits.hits.length>0){
                    const ar = r.data.hits.hits
                    const comData = { my_data: [], my_data_geo:{}}
                     //svr5 start
                     let my_data_geo = null
                     console.log('svj25 my_data_geo*********')
                     console.log(r5.data )
                     if( r5.data  &&  r5.data.countryTypes && r5.data.countryTypes.length>0){
                      my_data_geo = r5.data
                      comData.my_data_geo = my_data_geo
                     }
                     console.log(comData )
                     //svr5 end

                    let item , ob, upperOb
                    if( r2.data && r2.data.images[0]){
                        comData.my_images = r2.data.images[0]
                    }
                    ar.forEach(a_rec => {
                        ob= a_rec
                        if ( ob.price){
                            ob["flight_space_key"] = 'p' + ob.price['total']
                        }else{
                            ob["flight_space_key"] = 'p' + 1011
                        }
                       
                        comData.my_data.push(ob)
                    });
                    console.log('sv**OCT16 esqueryText partof svfly_esquery_data*********', svfly_esquery_data)
                    comData.svfly_esquery_data =  svfly_esquery_data  
                   
                   
                    dispatch(getFlySearchMultiplceCallsSuccess(comData))
                }
                else {
                    const comData = { items: [], my_data_geo :{}}
                     //svr5 start
                     let my_data_geo = null
                     console.log('svj25 my_data_geo*********')
                     console.log(r5.data )
                     if( r5.data  &&  r5.data.countryTypes && r5.data.countryTypes.length>0){
                      my_data_geo = r5.data
                      comData.my_data_geo = my_data_geo
                     }
                     console.log(comData )
                     //svr5 end
                    comData.svfly_esquery_data = {
                        my_orgqueryText: "09A",
                        my_dstqueryText: "ADQ",
                        "mcicountryOrg":"US",
                        "mcicountryDst":"US",     
                        STARTDATE:"2025-11-25",
                        ENDDATE: "2025-11-27",
                        DT_FORMAT: "%Y-%m-%d",
                        time_zone: "Asia/Kolkata",
                
                    }
                    dispatch(getFlySearchServerError(comData))
                }
                  
                   
                }
            )
        ).catch(
            e=>{dispatch(getFlySearchError(e))}
           
        )
    }
}


export function flyAndImagesSVFacet(sojPostRqFromPage,  svfly_esquery_data){
    console.log("sv OCT29 flyAndImagesSV ******sv_esquery_data********", svfly_esquery_data)
   
    
    return dispatch => {
        dispatch(getFlySearchBegin())
       //localhost:8000/amcosmosbika/ttr
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`

        const urlSoj = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/ttsvfacetttr/`
        //const urlSoj = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/mockttsvfacetttr`

        //const urlSoj = 'http://127.0.0.1:8000/trip/kkfromtosv/'
        let sojPostRq_old = {
            "query": {
              "match": {
                "sojourn_name": {
                  "query": "mancreek",
                  "operator": "and"
                }
              }
            }
          }

          let sojPostRq = {
            "dates": {
                "STARTDATE_ITN_TZAWARE_EST": "2025-11-25",
                "ENDDATE_ITN_TZAWARE_EST": "2025-11-27",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "Asia/Kolkata",
                "OP": "range"
            },
             "org": "09A",
            "dst":"ADQ"
        }
        /*
{
          "AIRPORT_ID" : 298,
          "ORIGIN_AIRPORT_CODE" : "LFW",
          "ORIGINCITY" : "Lome",
          "ORIGIN_AIRPORT_CITY" : "Lome",
          "ORIGIN_AIRPORT_COUNTRY" : "Togo",
          "ORIGIN_AIRPORT_TIMEZONE" : "Africa/Lome",
          "PORT_CODE_IATA" : "2J",
          "AIRLINES_DB_ID" : 470,
          "ORIGIN_AIRPORT_IATA" : "LFW",
          "DST_AIRPORT_CODE" : "OUA",
          "AIRLINES_VESSEL" : "M87 CRJ",
          "AIRLINES_NAME" : "Air Burkina",
          "AIRLINES_CODE_IATA" : "2J",
          "FLIGHT_SPACE_ID" : 89,
          "STARTDATE" : "2023-11-24",
          "ENDDATE" : "2026-12-01",
          "FLIGHT_SPACE_KEY" : "LFW@2J@LFW@OUA"
        }

        */
       
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        if(sojPostRqFromPage){
            sojPostRq = sojPostRqFromPage
        }
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers})
        ])
        .then(
            axios.spread((rFobAx,r2)=>{
                let rFob = rFobAx.data
                let r = {data:{}}
                r.data = rFob
                let p = {data:{}}
                
                if(rFob.length < 1){
                    p.data.hits = { hits: []}
                    r.data.hits = { hits: []}

                }else{
                    p.data.hits = { hits: []}
                    r.data.hits = { hits: []}

                    p.data.hits.hits  = rFob
                    r.data.hits.hits  = rFob

                }
              
               
               
                
               
                console.log('sv**OCT23 WED ****************  amb flighyr START')
                console.log(r)
                console.log('sv**OCT23 WED **************** r  END')
                if(r.data.hits.hits.length>0){
                    const ar = r.data.hits.hits
                    const comData = { my_data: []}
                    let item , ob, upperOb
                    if( r2.data && r2.data.images[0]){
                        comData.my_images = r2.data.images[0]
                    }
                    ar.forEach(a_rec => {
                        ob= a_rec
                        ob["flight_space_key"] = 'p' + ob.price['total']
                        comData.my_data.push(ob)
                    });
                    console.log('sv**OCT16 esqueryText partof svfly_esquery_data*********', svfly_esquery_data)
                    comData.svfly_esquery_data =  svfly_esquery_data  
                   
                   
                    dispatch(getFlySearchMultiplceCallsSuccess(comData))
                }
                else {
                    const comData = { items: []}
                    comData.svfly_esquery_data = {
                        my_orgqueryText: "09A",
                        my_dstqueryText: "ADQ",
                        "mcicountryOrg":"US",
                        "mcicountryDst":"US",
                        STARTDATE:"2025-11-25",
                        ENDDATE: "2025-11-27",
                        DT_FORMAT: "%Y-%m-%d",
                        time_zone: "Asia/Kolkata",
                
                    }
                    dispatch(getFlySearchSuccess(comData))
                }
                  
                   
                }
            )
        ).catch(
            e=>{dispatch(getFlySearchError(e))}
           
        )
    }
}

/**facet lsiteview  to do */
export function flyAndImagesSVFacet_esflights(sojPostRqFromPage, svfly_esquery_data){
    console.log("svoct17 sojAndImagesSVFacet ******sv_esquery_data", svfly_esquery_data)
   
    return dispatch => {
        dispatch(getFlySearchBegin())
       //svuilaFacetView
       
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
        const urlSoj = `${SV_SOJ_SVDJMOCK_ADDRESS}/trip/ttsvfacetttr/`
        //const urlSoj = 'http://127.0.0.1:8000/trip/ssfacetsv/'
       
          let sojPostRq ={
            "dates": {
                "STARTDATE_ITN_TZAWARE_EST": "2025-11-25",
                "ENDDATE_ITN_TZAWARE_EST": "2025-11-27",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "Asia/Kolkata",
                "OP": "range"
            },
            "facets": {
                "AIRLINES_NAME_IATA.keyword": ["2O","YR"]
                
            },
            "org": "09A",
            "dst": "ADQ"
        }
       
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        if(sojPostRqFromPage){
            sojPostRq = sojPostRqFromPage
        }
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers})
        ])
        .then(
            axios.spread((r,r2)=>{
                if(r.data.hits.hits.length>0){
                    const ar = r.data.hits.hits
                    const comData = { my_data: []}
                    let item , ob, upperOb
                    ar.forEach(a_rec => {
                        item = {}
                       
                        upperOb = a_rec['_source']
                        ob =lowercaseKeys(upperOb)

                        let rating = (ob['svr_vep_rating']? ob['svr_vep_rating'] : 0 )
                        let sv_rating = 'Excellent'
                       if(rating == 0){
                        sv_rating = 'Excellent'
    
                       }else if(rating == 1){
    
                        sv_rating = 'Poor'
                    }else if(rating == 2){
                        sv_rating = 'Fair'
                    }else if(rating == 3){
    
                        sv_rating = 'Recommend'
                    }else if(rating == 4){
                        sv_rating = 'Favorite'
                    }else if(rating == 5){
                        sv_rating = 'Excellent'
                    }else {
    
                        sv_rating = 'Excellent'
                       }
                       ob['sv_rating'] = sv_rating
                       ob['sv_availability_of_rooms'] = 8
                        /*
                        item['sojourncode']= ob['sojourncode']
                        item['vernacularcode']= ob['vernacularcode']
                        item['sojourn_name']= ob['sojourn_name']
                         comData.my_data.push(item)
                        */
    
    
                        comData.my_data.push(ob)
                    });
                    if( r2.data && r2.data[0]){
                        comData.my_images = r2.data[0]
                    }
                    console.log('sv**OCT16 esqueryText partof svfly_esquery_data*********', svfly_esquery_data)
                    comData.svfly_esquery_data =  svfly_esquery_data  
                   
                   
                    dispatch(getFlySearchMultiplceCallsSuccess(comData))
                }
                else {
                    const comData = { items: []}
                    comData.svfly_esquery_data = {
                        my_orgqueryText: "09A",
                        my_dstqueryText: "ADQ",
                        "mcicountryOrg":"US",
                        "mcicountryDst":"US",
                        STARTDATE:"2025-11-25",
                        ENDDATE: "2025-11-27",
                        DT_FORMAT: "%Y-%m-%d",
                        time_zone: "Asia/Kolkata",
                
                    }
                    dispatch(getFlySearchSuccess(comData))
                }
                  
                   
                }
            )
        ).catch(
            e=>{dispatch(getFlySearchError(e))}
           
        )
    }
}

const headers = {'Content-Type': 'application/json'}

function lowercaseKeys(obj) {
    return Object.keys(obj).reduce((accumulator, key) => {
      accumulator[key.toLowerCase()] = obj[key];
      return accumulator;
    }, {});
  }
//svsept26 start


export function flyAndImagesSV_svsworking_curr(sojPostRqFromPage,  svfly_esquery_data){
    console.log("svoct17 flyAndImagesSV ******sv_esquery_data", svfly_esquery_data)
   
    
    return dispatch => {
        dispatch(getFlySearchBegin())
       
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
        const urlSoj = `${SV_SOJ_SVDJMOCK_ADDRESS}/trip/kkfromtosv/`
        //const urlSoj = 'http://127.0.0.1:8000/trip/kkfromtosv/'
        let sojPostRq_old = {
            "query": {
              "match": {
                "sojourn_name": {
                  "query": "mancreek",
                  "operator": "and"
                }
              }
            }
          }

          let sojPostRq = {
            "dates": {
                "STARTDATE_ITN_TZAWARE_EST": "2025-11-25",
                "ENDDATE_ITN_TZAWARE_EST": "2025-11-27",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "Asia/Kolkata",
                "OP": "range"
            },
             "org": "09A",
            "dst":"ADQ"
        }
        /*
{
          "AIRPORT_ID" : 298,
          "ORIGIN_AIRPORT_CODE" : "LFW",
          "ORIGINCITY" : "Lome",
          "ORIGIN_AIRPORT_CITY" : "Lome",
          "ORIGIN_AIRPORT_COUNTRY" : "Togo",
          "ORIGIN_AIRPORT_TIMEZONE" : "Africa/Lome",
          "PORT_CODE_IATA" : "2J",
          "AIRLINES_DB_ID" : 470,
          "ORIGIN_AIRPORT_IATA" : "LFW",
          "DST_AIRPORT_CODE" : "OUA",
          "AIRLINES_VESSEL" : "M87 CRJ",
          "AIRLINES_NAME" : "Air Burkina",
          "AIRLINES_CODE_IATA" : "2J",
          "FLIGHT_SPACE_ID" : 89,
          "STARTDATE" : "2023-11-24",
          "ENDDATE" : "2026-12-01",
          "FLIGHT_SPACE_KEY" : "LFW@2J@LFW@OUA"
        }

        */
       
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        if(sojPostRqFromPage){
            sojPostRq = sojPostRqFromPage
        }
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers})
        ])
        .then(
            axios.spread((rFobAx,r2)=>{
                let rFob = rFobAx.data
                let r = {data:{}}
                r.data = rFob.svo
                let p = {data:{}}
                
                if(rFob.dbo.length < 1){
                    p.data.hits = { hits: []}

                }else{
                    p.data  = rFob.dbo

                }
                let prices = []
                let prices_idx = []
                let a_price = null;
                let prices_map = {}
               
                
                if(p.data.hits.hits.length>0){
                    prices_idx = p.data.hits.hits
                }
                prices_idx.forEach(p_rec => {
                    let p_item = {}
                    let p_lc = {}
                    p_item = p_rec['_source']
                    p_lc =lowercaseKeys(p_item)
                    prices.push(p_lc)
                   
                });
                prices.forEach(p => {
                    let k =p.spacekey
                    prices_map[k] = p
                });
                console.log('sv**SPET9 MONDAY **************** Prices_map START')
                console.log(prices_map)
                console.log('sv**SPET9 MONDAY **************** Prices_map END')
                if(r.data.hits.hits.length>0){
                    const ar = r.data.hits.hits
                    const comData = { my_data: []}
                    let item , ob, upperOb
                    if( r2.data && r2.data.images[0]){
                        comData.my_images = r2.data.images[0]
                    }
                    ar.forEach(a_rec => {
                        item = {}
                       
                        upperOb = a_rec['_source']
                        ob =lowercaseKeys(upperOb)

                       
                   
                    ob['sv_availability_of_rooms'] = 8
                    let k_sv = ob['FLIGHT_SPACE_KEY'.toLowerCase()]
                    a_price = prices_map[k_sv]
                    if(a_price){

                        ob = _.merge(ob, a_price)
                    }
                          
                       /*
                        item['sojourncode']= ob['sojourncode']
                        item['vernacularcode']= ob['vernacularcode']
                        item['sojourn_name']= ob['sojourn_name']
                         comData.my_data.push(item)
                        */
                       
    
                        comData.my_data.push(ob)
                    });
                    console.log('sv**OCT16 esqueryText partof svfly_esquery_data*********', svfly_esquery_data)
                    comData.svfly_esquery_data =  svfly_esquery_data  
                   
                   
                    dispatch(getFlySearchMultiplceCallsSuccess(comData))
                }
                else {
                    const comData = { items: []}
                    comData.svfly_esquery_data = {
                        my_orgqueryText: "09A",
                        my_dstqueryText: "ADQ",
                        "mcicountryOrg":"US",
                        "mcicountryDst":"US",
                        STARTDATE:"2025-11-25",
                        ENDDATE: "2025-11-27",
                        DT_FORMAT: "%Y-%m-%d",
                        time_zone: "Asia/Kolkata",
                
                    }
                    dispatch(getFlySearchSuccess(comData))
                }
                  
                   
                }
            )
        ).catch(
            e=>{dispatch(getFlySearchError(e))}
           
        )
    }
}
//svsept26 end

export function flyAndImagesSV_svgood_cur(sojPostRqFromPage){
    return dispatch => {
        dispatch(getFlySearchBegin())
       
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
        const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuilaFlightQueryFinal`
        let sojPostRq_old = {
            "query": {
              "match": {
                "sojourn_name": {
                  "query": "mancreek",
                  "operator": "and"
                }
              }
            }
          }

          let sojPostRq = {
            "query": {
                "multi_match": {
                    "fields": [
                        "ORIGIN_AIRPORT_IATA",
                        "ORIGIN_AIRPORT_CITY",
                        "ORIGIN_AIRPORT_COUNTRY",
                        "AIRLINES_NAME",
                        
                         "FLIGHT_SPACE_KEY"
                       
                    ],
                    "query": "LIM",
                    "operator": "or",
                    "fuzziness": "AUTO"
                }
            },
            "post_filter": {
                "range": {
                    "STARTDATE": {
                        "gte": "2023-10-24",
                        "lt": "2023-11-27",
                        "time_zone": "+01:00"
                    }
                }
            }
        }
        /*
{
          "AIRPORT_ID" : 298,
          "ORIGIN_AIRPORT_CODE" : "LFW",
          "ORIGINCITY" : "Lome",
          "ORIGIN_AIRPORT_CITY" : "Lome",
          "ORIGIN_AIRPORT_COUNTRY" : "Togo",
          "ORIGIN_AIRPORT_TIMEZONE" : "Africa/Lome",
          "PORT_CODE_IATA" : "2J",
          "AIRLINES_DB_ID" : 470,
          "ORIGIN_AIRPORT_IATA" : "LFW",
          "DST_AIRPORT_CODE" : "OUA",
          "AIRLINES_VESSEL" : "M87 CRJ",
          "AIRLINES_NAME" : "Air Burkina",
          "AIRLINES_CODE_IATA" : "2J",
          "FLIGHT_SPACE_ID" : 89,
          "STARTDATE" : "2023-11-24",
          "ENDDATE" : "2026-12-01",
          "FLIGHT_SPACE_KEY" : "LFW@2J@LFW@OUA"
        }

        */
       
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        if(sojPostRqFromPage){
            sojPostRq = sojPostRqFromPage
        }
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers})
        ])
        .then(
            axios.spread((rFobAx,r2)=>{
                let rFob = rFobAx.data
                let r = {data:{}}
                r.data = rFob.svo
                let p = {data:{}}
                
                if(rFob.dbo.length < 1){
                    p.data.hits = { hits: []}

                }else{
                    p.data  = rFob.dbo

                }
                let prices = []
                let prices_idx = []
                let a_price = null;
                let prices_map = {}
               
                
                if(p.data.hits.hits.length>0){
                    prices_idx = p.data.hits.hits
                }
                prices_idx.forEach(p_rec => {
                    let p_item = {}
                    let p_lc = {}
                    p_item = p_rec['_source']
                    p_lc =lowercaseKeys(p_item)
                    prices.push(p_lc)
                   
                });
                prices.forEach(p => {
                    let k =p.spacekey
                    prices_map[k] = p
                });
                console.log('sv**SPET9 MONDAY **************** Prices_map START')
                console.log(prices_map)
                console.log('sv**SPET9 MONDAY **************** Prices_map END')
                if(r.data.hits.hits.length>0){
                    const ar = r.data.hits.hits
                    const comData = { my_data: []}
                    let item , ob, upperOb
                    if( r2.data && r2.data.images[0]){
                        comData.my_images = r2.data.images[0]
                    }
                    ar.forEach(a_rec => {
                        item = {}
                       
                        upperOb = a_rec['_source']
                        ob =lowercaseKeys(upperOb)

                       
                   
                    ob['sv_availability_of_rooms'] = 8
                    let k_sv = ob['FLIGHT_SPACE_KEY'.toLowerCase()]
                    a_price = prices_map[k_sv]
                    if(a_price){

                        ob = _.merge(ob, a_price)
                    }
                          
                       /*
                        item['sojourncode']= ob['sojourncode']
                        item['vernacularcode']= ob['vernacularcode']
                        item['sojourn_name']= ob['sojourn_name']
                         comData.my_data.push(item)
                        */
                       
    
                        comData.my_data.push(ob)
                    });
                   
                   
                    dispatch(getFlySearchMultiplceCallsSuccess(comData))
                }
                else {
                    const comData = { items: []}
                    dispatch(getFlySearchSuccess(comData))
                }
                  
                   
                }
            )
        ).catch(
            e=>{dispatch(getFlySearchError(e))}
           
        )
    }
}



export const getFlySearchSuccess = (data) => dispatch => {
    dispatch({
        type: typesJetFly.GET_JET_FLY_SUCCESS,
        payload: data
    })
}

export const getFlySearchServerError = (data) => dispatch => {
    let eob = {
        "timestamp": "2015-08-23T02:27:18.038+0000",
        "status": 500,
        "error": "FlyServer Error",
        "message": "No Resulst Found.Please refinse search and try again",
        "path": "/kk/svaddressDetailPost"
    }
    dispatch({
        type:typesJetFly.GET_JET_FLY_ERROR,
        error:eob
    })
}

export const getFlySearchMultiplceCallsSuccess = (data) => dispatch => {
    dispatch({
        type: "GET_JET_FLY_SUCCESS",
        payload: data
    })
}

export const getFlySearchBegin = () => dispatch => {
    dispatch({
        type:typesJetFly.GET_JET_FLY_BEGIN
        
    })
}

export const getFlySearchError = (e) =>dispatch => {
    dispatch({
        type:typesJetFly.GET_JET_FLY_ERROR,
        error:e
    })
}


export const getFindEsQueryDataSuccess = (data) => dispatch => {
   
    dispatch({
       type: "SVFINDFILTERS_SUCCESS",
       payload: data
   })

  
}

export const saveFindEsQueryDataSuccess = (data) => dispatch => {
    console.log('sv*********saveFindEsQueryDataSuccess  start')
    console.log(data)
    console.log('sv*********saveFindEsQueryDataSuccess  end')
   
     
     let new_esquery_data = { svfly_esquery_data : data.svfly_esquery_data}
     dispatch(getFindEsQueryDataSuccess(new_esquery_data))
}

/*SVNOV17 START flyLoadsvmciData */
export const saveUserOfferOld=(data)=>{
    console.log('action flyLoadsvmciData gets Hardcoded Data we need to make form number of travelers')
    console.log(data)
   // console.log(data)
    //polulate from numTravellers
    let my_data_svtoffee ={
        "customerId": 7,
        "svt": "ba53a90c9b1d3d7906af5a561b926cc7",
        "svcook": "{\"season\":\"GREEN\",\"sojourncode\":\"100\",\"vernacularcode\":\"EN\"}"
    }
    

    let comData = {"my_data_svtoffee" : data.my_data_svtoffee}
    var action = {
       id:-1,
        type: 'FLYMYRESERVATIONS_PRIMARY_SVTFE',
        payload:comData
    }
    console.log(action)
    return action

}


/* check where is svtv* and them remove from agg */
export function saveUserOffer(obTof){
    console.log('%%%%%%%%%%%%%%%sv++++DEC2 REST API  essearch/svsaveTokenOffer For _doc swith obTof:' )

    console.log(obTof)
    return dispatch => {
        dispatch(svSaveUserOfferBegin())
      
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
       let body = {
        "customerId": 7,
        "svt": "ba53a90c9b1d3d7906af5a561b926cc7",
        "svcook": "{\"season\":\"GREEN\",\"sojourncode\":\"100\",\"vernacularcode\":\"EN\"}"
    }
          body = obTof.my_data_svtoffee

         // body.id = 97
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svsaveTokenOffer`
      
        axios.post(url, body, {headers:headers})
        .then(
            r => {
                if( r.data ){
                    const ob = r.data
                    if(ob.status && ob.status !=200){
                        let eeb = {

                        }
                        eeb.errob = ob
                        dispatch(getSaveUserOfferError(eeb))
                    }else{
                        if(ob.id && (ob.id > 0)){
                            console.log('sv save success')
                            const comData = { my_data_addressdet:  ob }
    
                            dispatch(geSaveUserOfferSuccess(comData))
                        }else{
                            let eeb = {

                            }
                            eeb.errob = ob
                            dispatch(getSaveUserOfferError(eeb))
                        }
    
                      
                    }
                    
                }
                else {
                    const comData = { my_data_svtoffee: {
                        "customerId": 7,
                        "svt": "ba53a90c9b1d3d7906af5a561b926cc7",
                        "svcook": "{\"season\":\"GREEN\",\"sojourncode\":\"100\",\"vernacularcode\":\"EN\"}"
                    }}
                    console.log('errr********', comData)
                    dispatch(getSaveUserOfferError(comData))
                }
            }
        ).catch(
            e=>{
                console.log('errr**REAL******')
                console.log(e)
                dispatch(getSaveUserOfferError(e)) }
        )
    }
}

export const  svSaveUserOfferBegin = () => dispatch => {
    dispatch({
        type:'GET_SAVEUSERSVOFFER_BEGIN'
        
    })
}


export const geSaveUserOfferSuccess = (data) => dispatch => {


    dispatch({
        type: 'GET_SAVEUSERSVOFFER_SUCCESS',
        payload: data
    })
/*
    let flight_space_key ='1@4@1@ADQ'
    history.push(`/svflysearch/svredfly/${flight_space_key}`)
    */
}

export const getSaveUserOfferError = (e) =>dispatch => {
    console.log(e)
    dispatch({
        type:'GET_SAVEUSERSVOFFER_ERROR',
        payload:e
    })
}

/*svdec2 end*/

export const flySaveMcitytReviewSuccess = (dataOb) => dispatch => {
    dispatch({
        type: 'SAVEMCITY_FLYREVIEW_SUCCESS',
        payload: dataOb
    })
}

/*svdec2 start*/
export const flyLoadsvmciData=(data)=>{
    console.log('action flyLoadsvmciData gets Hardcoded Data we need to make form number of travelers')
    console.log(data)
   // console.log(data)
    //polulate from numTravellers
    let my_data_svmci ={
        "id": "addLeft_step",
        "testlastName": "svlondon",
        "dateOfBirth": "1982-01-15",
        "members": [
            {
                "tid": 1,
                "dateOfBirth": "1982-01-15",
                "gender": "MALE",
                "firstName": "Svbsv",
                "lastName": "Infinity",
                "emailAddress": "svr@yahoo.com",
                "memphones": [
                    {
                        "deviceType": "MOBILE",
                        "countryCallingCode": "34",
                        "number": "480080085"
                    }
                ],
                "members": [
                    {
                        "documentType": "IDENTITY_CARD",
                        "birthPlace": "Sanfrancisco",
                        "issuanceLocation": "Sanfrancisco",
                        "issuanceDate": "2015-04-13",
                        "documentNumber": "00000069",
                        "expiryDate": "2025-04-13",
                        "issuanceCountry": "US",
                        "validityCountry": "US",
                        "nationality": "US",
                        "holder": "Y"
                    }
                ],
                "id": "addLeft_STEP",
                "gene": "addLeft_STEP",
                "clubName": "Soccer"
            },
            {
                "tid": 2,
                "dateOfBirth": "1982-01-15",
                "gender": "MALE",
                "firstName": "Seteve",
                "lastName": "Borrow",
                "emailAddress": "steve@yahoo.com",
                "memphones": [
                    {
                        "deviceType": "MOBILE",
                        "countryCallingCode": "1",
                        "number": "480080081"
                    }
                ],
                "members": [
                    {
                        "documentType": "IDENTITY_CARD",
                        "birthPlace": "Sanfrancisco",
                        "issuanceLocation": "Sanfrancisco",
                        "issuanceDate": "2015-04-13",
                        "documentNumber": "00000069",
                        "expiryDate": "2025-04-13",
                        "issuanceCountry": "US",
                        "validityCountry": "US",
                        "nationality": "US",
                        "holder": "Y"
                    }
                ],
                "id": "addLeft_STEP1",
                "gene": "addLeft_STEP1",
                "clubName": "Soccer"
            }
        ],
           "gender": "MALE"
    }
    

    let comData = {"my_data_svmci" : my_data_svmci}
    var action = {
       id:-1,
        type: 'FLYMYRESERVATIONS_PRIMARY_SVMCI',
        payload:comData
    }
    console.log(action)
    return action

}

/*svdec2 end*/
/*svaug21 start  flyCountryCodeSV flyAndImagesSV  */

export function flyAndImagesSV_workingAug25(sojPostRqFromPage,  svfly_esquery_data){
    console.log("sv NOV!5*** flyAndImagesSV ******sv_esquery_data********", svfly_esquery_data)
   
    
    return dispatch => {
        dispatch(getFlySearchBegin())
       //localhost:8000/amcosmosbika/ttsvfacetttr
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
        let urlBridge = null
        let urlSoj = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/ttsvfacetttr/`
        if(svfly_esquery_data && svfly_esquery_data['esqueryTripType']){
            if(svfly_esquery_data['esqueryTripType'] == 'onewaytrip'){
                urlSoj = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/ttsvfacetttr/`
                urlBridge = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/amcosmosbika/ttsvfacetttr/`
                urlSoj = SV_SOJ_SVDJMOCK_BRIDGE === "SVINGEST" ? urlBridge : urlSoj
            }else if(svfly_esquery_data['esqueryTripType'] == 'roundtrip'){
                
                urlSoj = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/eesvfaceteer`  
                urlBridge = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/amcosmosbika/eesvfaceteer`
                urlSoj = SV_SOJ_SVDJMOCK_BRIDGE === "SVINGEST" ? urlBridge : urlSoj

            }else if(svfly_esquery_data['esqueryTripType'] == 'multicity'){
                urlSoj = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/xxsvfacemultixx` 
                
                urlBridge = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/amcosmosbika/xxsvfacemultixx`
                urlSoj = SV_SOJ_SVDJMOCK_BRIDGE === "SVINGEST" ? urlBridge : urlSoj
                //essearch/xxsvfacemultixx 
                //urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/xxsvfacemultixx` 
            }else{
                urlSoj = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/ttsvfacetttr/`

                urlBridge = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/amcosmosbika/ttsvfacetttr/`
                urlSoj = SV_SOJ_SVDJMOCK_BRIDGE === "SVINGEST" ? urlBridge : urlSoj
            }
        }

        
       // const urlSoj = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/mmmockttsvfacetttr`

        //const urlSoj = 'http://127.0.0.1:8000/trip/kkfromtosv/'
        let sojPostRq_old = {
            "query": {
              "match": {
                "sojourn_name": {
                  "query": "mancreek",
                  "operator": "and"
                }
              }
            }
          }

          let sojPostRq = {
            "dates": {
                "STARTDATE_ITN_TZAWARE_EST": "2025-11-25",
                "ENDDATE_ITN_TZAWARE_EST": "2025-11-27",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "Asia/Kolkata",
                "OP": "range"
            },
             "org": "09A",
            "dst":"ADQ"
        }
        /*
{
          "AIRPORT_ID" : 298,
          "ORIGIN_AIRPORT_CODE" : "LFW",
          "ORIGINCITY" : "Lome",
          "ORIGIN_AIRPORT_CITY" : "Lome",
          "ORIGIN_AIRPORT_COUNTRY" : "Togo",
          "ORIGIN_AIRPORT_TIMEZONE" : "Africa/Lome",
          "PORT_CODE_IATA" : "2J",
          "AIRLINES_DB_ID" : 470,
          "ORIGIN_AIRPORT_IATA" : "LFW",
          "DST_AIRPORT_CODE" : "OUA",
          "AIRLINES_VESSEL" : "M87 CRJ",
          "AIRLINES_NAME" : "Air Burkina",
          "AIRLINES_CODE_IATA" : "2J",
          "FLIGHT_SPACE_ID" : 89,
          "STARTDATE" : "2023-11-24",
          "ENDDATE" : "2026-12-01",
          "FLIGHT_SPACE_KEY" : "LFW@2J@LFW@OUA"
        }

        */
       
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        if(sojPostRqFromPage){
            sojPostRq = sojPostRqFromPage
        }
        const urlGeoList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/geography`
        const bodyGeoList = {"docId":["USA"],"hsetname":"HotelInvDB"}
       
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers}),
            axios.post(urlGeoList, bodyGeoList, {headers:headers}),
        ])
        .then(
            axios.spread((rFobAx,r2,r5)=>{
           
               let rFob = rFobAx.data
               /*
               let rFob = [{
                "airport_id" : 298,
                "origin_airport_code" : "lfw",
                "origincity" : "lome",
                "origin_airport_city" : "lome",
                "origin_airport_country" : "togo",
                "origin_airport_timezone" : "africa/lome",
                "port_code_iata" : "2j",
                "airlines_db_id" : 470,
                "origin_airport_iata" : "lfw",
                "dst_airport_code" : "oua",
                "airlines_vessel" : "m87 crj",
                "airlines_name" : "air burkina",
                "airlines_code_iata" : "2j",
                "flight_space_id" : 89,
                "startdate" : "2023-11-24",
                "enddate" : "2026-12-01",
                "flight_space_key" : "lfw@2j@lfw@oua"
              }]
              */
                let r = {data:{}}
                r.data = rFob
                let p = {data:{}}
                
                if(rFob.length < 1){
                    p.data.hits = { hits: []}
                    r.data.hits = { hits: []}

                }else{
                    p.data.hits = { hits: []}
                    r.data.hits = { hits: []}

                    p.data.hits.hits  = rFob
                    r.data.hits.hits  = rFob

                }
              
               
               
                
               
                console.log('sv**OCT23 WED ****************  amb flighyr START')
                console.log(r)
                console.log('sv**OCT23 WED **************** r  END')
                if(r.data.hits.hits.length>0){
                    const ar = r.data.hits.hits
                    const comData = { my_data: [], my_data_geo:{}}
                     //svr5 start
                     let my_data_geo = null
                     console.log('svj25 my_data_geo*********')
                     console.log(r5.data )
                     if( r5.data  &&  r5.data.countryTypes && r5.data.countryTypes.length>0){
                      my_data_geo = r5.data
                      comData.my_data_geo = my_data_geo
                     }
                     console.log(comData )
                     //svr5 end

                    let item , ob, upperOb
                    if( r2.data && r2.data.images[0]){
                        comData.my_images = r2.data.images[0]
                    }
                    ar.forEach(a_rec => {
                        ob= a_rec
                        if ( ob.price){
                            ob["flight_space_key"] = 'p' + ob.price['total']
                        }else{
                            ob["flight_space_key"] = 'p' + 1011
                        }
                       
                        comData.my_data.push(ob)
                    });
                    console.log('sv**OCT16 esqueryText partof svfly_esquery_data*********', svfly_esquery_data)
                    comData.svfly_esquery_data =  svfly_esquery_data  
                   
                   
                    dispatch(getFlySearchMultiplceCallsSuccess(comData))
                }
                else {
                    const comData = { items: [], my_data_geo :{}}
                     //svr5 start
                     let my_data_geo = null
                     console.log('svj25 my_data_geo*********')
                     console.log(r5.data )
                     if( r5.data  &&  r5.data.countryTypes && r5.data.countryTypes.length>0){
                      my_data_geo = r5.data
                      comData.my_data_geo = my_data_geo
                     }
                     console.log(comData )
                     //svr5 end
                    comData.svfly_esquery_data = {
                        my_orgqueryText: "09A",
                        my_dstqueryText: "ADQ",
                        "mcicountryOrg":"US",
                        "mcicountryDst":"US",
                        STARTDATE:"2025-11-25",
                        ENDDATE: "2025-11-27",
                        DT_FORMAT: "%Y-%m-%d",
                        time_zone: "Asia/Kolkata",
                
                    }
                    dispatch(getFlySearchServerError(comData))
                }
                  
                   
                }
            )
        ).catch(
            e=>{dispatch(getFlySearchError(e))}
           
        )
    }
}

/*sv aug26 start */

export function flyAndImagesSV(sojPostRqFromPage,  svfly_esquery_data){
    console.log("sv NOV!5*** flyAndImagesSV ******sv_esquery_data********", svfly_esquery_data)
   
    
    return dispatch => {
        dispatch(getFlySearchBegin())
       //localhost:8000/amcosmosbika/ttsvfacetttr
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
        let urlBridge = null
        let urlSoj = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/ttsvfacetttr/`
        if(svfly_esquery_data && svfly_esquery_data['esqueryTripType']){
            if(svfly_esquery_data['esqueryTripType'] == 'onewaytrip'){
                urlSoj = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/ttsvfacetttr/`
                urlBridge = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/amcosmosbika/ttsvfacetttrIata`
                urlSoj = SV_SOJ_SVDJMOCK_BRIDGE === "SVINGEST" ? urlBridge : urlSoj
            }else if(svfly_esquery_data['esqueryTripType'] == 'roundtrip'){
                //svaug28
                //urlSoj = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/eesvfaceteer`  
                urlSoj = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/eesvfaceteer`  
                urlBridge = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/amcosmosbika/eesvfaceteerIata`
                urlSoj = SV_SOJ_SVDJMOCK_BRIDGE === "SVINGEST" ? urlBridge : urlSoj

            }else if(svfly_esquery_data['esqueryTripType'] == 'multicity'){
                urlSoj = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/xxsvfacemultixx` 
                
                urlBridge = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/amcosmosbika/xxsvfacemultixxIata`
                urlSoj = SV_SOJ_SVDJMOCK_BRIDGE === "SVINGEST" ? urlBridge : urlSoj
                //essearch/xxsvfacemultixx 
                //urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/xxsvfacemultixx` 
            }else{
                urlSoj = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/ttsvfacetttr/`

                urlBridge = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/amcosmosbika/ttsvfacetttrIata`
                urlSoj = SV_SOJ_SVDJMOCK_BRIDGE === "SVINGEST" ? urlBridge : urlSoj
            }
        }

        
       // const urlSoj = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/mmmockttsvfacetttr`

        //const urlSoj = 'http://127.0.0.1:8000/trip/kkfromtosv/'
        let sojPostRq_old = {
            "query": {
              "match": {
                "sojourn_name": {
                  "query": "mancreek",
                  "operator": "and"
                }
              }
            }
          }

          let sojPostRq = {
            "dates": {
                "STARTDATE_ITN_TZAWARE_EST": "2025-11-25",
                "ENDDATE_ITN_TZAWARE_EST": "2025-11-27",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "Asia/Kolkata",
                "OP": "range"
            },
             "org": "09A",
            "dst":"ADQ"
        }
        /*
{
          "AIRPORT_ID" : 298,
          "ORIGIN_AIRPORT_CODE" : "LFW",
          "ORIGINCITY" : "Lome",
          "ORIGIN_AIRPORT_CITY" : "Lome",
          "ORIGIN_AIRPORT_COUNTRY" : "Togo",
          "ORIGIN_AIRPORT_TIMEZONE" : "Africa/Lome",
          "PORT_CODE_IATA" : "2J",
          "AIRLINES_DB_ID" : 470,
          "ORIGIN_AIRPORT_IATA" : "LFW",
          "DST_AIRPORT_CODE" : "OUA",
          "AIRLINES_VESSEL" : "M87 CRJ",
          "AIRLINES_NAME" : "Air Burkina",
          "AIRLINES_CODE_IATA" : "2J",
          "FLIGHT_SPACE_ID" : 89,
          "STARTDATE" : "2023-11-24",
          "ENDDATE" : "2026-12-01",
          "FLIGHT_SPACE_KEY" : "LFW@2J@LFW@OUA"
        }

        */
       
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        if(sojPostRqFromPage){
            sojPostRq = sojPostRqFromPage
            /*svaug29 start
            "svcities": [
        {
            "id": "1",
            "originLocationCode": "SEA",
            "destinationLocationCode": "JFK",
            "departureDateTimeRange": {
                "date": "2025-09-20T00:49:28.300Z"
            }
        },
        {
            "id": "2",
            "originLocationCode": "JFK",
            "destinationLocationCode": "BOS",
            "departureDateTimeRange": {
                "date": "2025-09-24T00:49:36.555Z"
            }
        },
        {
            "id": "3",
            "originLocationCode": "BOS",
            "destinationLocationCode": "SEA",
            "departureDateTimeRange": {
                "date": "2025-09-28T00:49:36.559Z"
            }
        }
    ]
            */
    if(svfly_esquery_data && svfly_esquery_data['esqueryTripType']){
        if(svfly_esquery_data['esqueryTripType'] === 'multicity'){

            let {svcities} = sojPostRq
            let mda = []
            if(svcities){
                mda = svcities
            }
            let  doc = null, vob = null,  odr = null
            let vob_date = null,vob_is_date = null
            let s = null, m =null, mofval = null, mofval_str = null
            for(let k=0; k < mda.length; k++){
                doc = mda[k]
                odr = doc["departureDateTimeRange"]

                vob=   odr["date"]
                  if(_.isString(vob) ){
                    s =  odr["date"]
                    m =s.substring(0,10) 
                    odr["date"] = m
                  }else{
                    vob_date = vob._d
                    vob_is_date = _.isDate(vob)
                   
                    //console.log(vob_date)
                    mofval = moment(vob_date)
                    mofval_str = mofval.format('YYYY-MM-DD')
                    s = mofval_str
                    m = s
                    odr["date"] = m
                    
                  }
                 

            }
            console.log('sv aug29***mcitu actions date mod***')
            console.log(sojPostRq)

        }
    }
           
            /*svaug29 end*/
        }

        

        const urlGeoList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/geography`
        const bodyGeoList = {"docId":["USA"],"hsetname":"HotelInvDB"}
       
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers}),
            axios.post(urlGeoList, bodyGeoList, {headers:headers}),
        ])
        .then(
            axios.spread((rFobAx,r2,r5)=>{
           
               let rFobMerge = rFobAx.data
               let rFob = rFobMerge.svflighs
               let airlines = rFobMerge.airlines
               let am = {}
               airlines.forEach((o)=>{
                   am[o.IATA] = o
               })
               let airports = rFobMerge.airports
               let ap = {}
               airports.forEach((o)=>{
                ap[o.IATA] = o
            })

               /*
               let rFob = [{
                "airport_id" : 298,
                "origin_airport_code" : "lfw",
                "origincity" : "lome",
                "origin_airport_city" : "lome",
                "origin_airport_country" : "togo",
                "origin_airport_timezone" : "africa/lome",
                "port_code_iata" : "2j",
                "airlines_db_id" : 470,
                "origin_airport_iata" : "lfw",
                "dst_airport_code" : "oua",
                "airlines_vessel" : "m87 crj",
                "airlines_name" : "air burkina",
                "airlines_code_iata" : "2j",
                "flight_space_id" : 89,
                "startdate" : "2023-11-24",
                "enddate" : "2026-12-01",
                "flight_space_key" : "lfw@2j@lfw@oua"
              }]
              */
                let r = {data:{}}
                r.data = rFob
                let p = {data:{}}
                
                if(rFob.length < 1){
                    p.data.hits = { hits: []}
                    r.data.hits = { hits: []}

                }else{
                    p.data.hits = { hits: []}
                    r.data.hits = { hits: []}

                    p.data.hits.hits  = rFob
                    r.data.hits.hits  = rFob

                }
              
               
               
                
               
                console.log('sv**OCT23 WED ****************  amb flighyr START')
                console.log(r)
                console.log('sv**OCT23 WED **************** r  END')
                if(r.data.hits.hits.length>0){
                    const ar = r.data.hits.hits
                    const comData = { my_data: [], my_data_geo:{}}
                     //svr5 start
                     let my_data_geo = null
                     console.log('svj25 my_data_geo*********')
                     console.log(r5.data )
                     if( r5.data  &&  r5.data.countryTypes && r5.data.countryTypes.length>0){
                      my_data_geo = r5.data
                      comData.my_data_geo = my_data_geo
                     }
                     console.log(comData )
                     //svr5 end

                    let item , ob, upperOb
                    if( r2.data && r2.data.images[0]){
                        comData.my_images = r2.data.images[0]
                    }
                    ar.forEach(a_rec => {
                        ob= a_rec
                        if ( ob.price){
                            ob["flight_space_key"] = 'p' + ob.price['total']
                        }else{
                            ob["flight_space_key"] = 'p' + 1011
                        }
                       
                        comData.my_data.push(ob)
                    });
                    console.log('sv**OCT16 esqueryText partof svfly_esquery_data*********', svfly_esquery_data)
                    
                    //sv aug28
                    
                    svfly_esquery_data.amap = am
                    svfly_esquery_data.airlines = airlines
                    svfly_esquery_data.pmap = ap
                    
                    comData.svfly_esquery_data =  svfly_esquery_data  
                   
                   
                    dispatch(getFlySearchMultiplceCallsSuccess(comData))
                }
                else {
                    const comData = { items: [], my_data_geo :{}}
                     //svr5 start
                     let my_data_geo = null
                     console.log('svj25 my_data_geo*********')
                     console.log(r5.data )
                     if( r5.data  &&  r5.data.countryTypes && r5.data.countryTypes.length>0){
                      my_data_geo = r5.data
                      comData.my_data_geo = my_data_geo
                     }
                     console.log(comData )
                     //svr5 end
                    comData.svfly_esquery_data = {
                        my_orgqueryText: "09A",
                        my_dstqueryText: "ADQ",
                        "mcicountryOrg":"US",
                        "mcicountryDst":"US",
                        STARTDATE:"2025-11-25",
                        ENDDATE: "2025-11-27",
                        DT_FORMAT: "%Y-%m-%d",
                        time_zone: "Asia/Kolkata",
                
                    }
                    dispatch(getFlySearchServerError(comData))
                }
                  
                   
                }
            )
        ).catch(
            e=>{dispatch(getFlySearchError(e))}
           
        )
    }
}

/*svaug26 end */